export class PromotionMessageLiteModel {
  id?: number;
  code: string;

  type_message_id: number;
  type_message?: string;

  description: string;

}

export class PromotionMessageModel extends PromotionMessageLiteModel{

  discount_type_id: number;
  discount_type?: string;

  wizard_id: number;

  discount_amt: number;
  coupon_type: string;
  notes: string;

  cluster_id: number;
  cluster?: string;

  flg_fidelity: string;
  flg_card_holder: string;

  barcode_type_pid: number;
  barcode_type?: string;

  barcode: string;
  flg_open_coupon: string;
  days_from_emission: number;
  stretch_value: number;
  threshold_value: number;

  fe_template_id: number;
  fe_template?: string;

  redemption_template_id: number;
  redemption_template?: string;

  emission_template_id: number;
  emission_template?: string;
}

export class PromotionMessageLayoutModel {
  id?: number;

  message_id: number;

  ochannel_id: number;
  ochannel?: string;

  message_layout_id: number;
  message_layout?: string;

  start_visibility_date: Date;

  end_visibility_date: Date;
}

export class PromotionMessageWizardModel {
  name: string;
  min?: number;
  max?: number;
  default?: any;
  readonly?: boolean;
  mandatory?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/promotion-message.model.ts